(function () {
  'use strict';

  angular
    .module('app')
    .component(
      'clientProfileProductCategorySettingList',
      clientProfileProductCategorySettingList()
    );

  function clientProfileProductCategorySettingList() {
    return {
      bindings: {
        clientProfileSeasonId: '<',
        clientProfileId: '<',
        productCategorySettings: '=',
        priceLists: '<',
        mode: '<',
        onProductCategorySettingsUpdated: '&',
      },
      controller: ClientProfileProductCategorySettingComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/client-profiles/components/product-category-settings/product-category-setting-list/' +
        'product-category-setting-list.component.html',
    };
  }

  ClientProfileProductCategorySettingComponent.$inject = [
    'UtilService',
    'ClientProfileProductCategorySettingService',
    'ProductCategoryService',
  ];

  function ClientProfileProductCategorySettingComponent(
    UtilService,
    ClientProfileProductCategorySettingService,
    ProductCategoryService
  ) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    vm.productTypes = vm.UtilService.getProductTypes();
    vm.productCategoriesByType = [];

    // Methods
    vm.addProductCategorySettings = addProductCategorySettings;
    vm.removeProductCategorySettings = removeProductCategorySettings;
    vm.deleteProductCategorySettings = deleteProductCategorySettings;
    vm.saveProductCategorySettings = saveProductCategorySettings;
    vm.selectProductType = selectProductType;
    vm.selectProductCategory = selectProductCategory;
    vm.toggleEditMode = toggleEditMode;

    vm.$onInit = function () {
      if (vm.mode !== 'create') {
        setProductCategorySettings(vm.productCategorySettings);
      }
    };

    function setProductCategorySettings(clientProfileProductCategorySettings) {
      vm.productCategorySettings =
        ClientProfileProductCategorySettingService.setProductCategorySettings(
          clientProfileProductCategorySettings,
          vm.priceLists
        );
    }

    function addProductCategorySettings() {
      vm.addMode = true;

      var settingsByPriceList = [];
      vm.priceLists.forEach(function (priceList) {
        settingsByPriceList.push({
          percentage: 0,
          price_list_id: priceList.id,
        });
      });

      vm.productCategorySettings.push({
        product_category: {},
        settingsByPriceList: settingsByPriceList,
        createMode: true,
      });

      vm.formErrors = false;
    }

    function removeProductCategorySettings(index) {
      vm.mode = 'view';
      vm.addMode = false;

      vm.availableProductCategoriesByType = null;

      vm.productCategorySettings.splice(index, 1);
    }

    function deleteProductCategorySettings(productCategorySetting, index) {
      var successCallback = function () {
        removeProductCategorySettings(index);

        vm.onProductCategorySettingsUpdated();
      };

      ClientProfileProductCategorySettingService.deleteProductCategorySettings(
        productCategorySetting.settingsByPriceList,
        vm.clientProfileId,
        vm.clientProfileSeasonId,
        successCallback
      );
    }

    // Save settings for product categories, for all price lists
    function saveProductCategorySettings(
      productCategorySetting,
      isProductCategorySettingFormValid
    ) {
      vm.formErrors = false;

      if (!isProductCategorySettingFormValid) {
        vm.formErrors = true;

        return;
      }

      if (productCategorySetting.editMode) {
        delete productCategorySetting.originalValues;
      }

      vm.mode = 'view';

      vm.sendingForm = true;
      ClientProfileProductCategorySettingService.saveProductCategorySettings(
        productCategorySetting.settingsByPriceList,
        vm.clientProfileId,
        vm.clientProfileSeasonId
      ).then(function (response) {
        if (response) {
          // Success
          if (productCategorySetting.createMode) {
            setProductCategorySettings(response);
            productCategorySetting.createMode = false;
          }

          productCategorySetting.editMode = false;

          vm.UtilService.itemListChanged(productCategorySetting.product_category.id);

          vm.onProductCategorySettingsUpdated();
        } else {
          vm.formErrors = true;
        }

        vm.addMode = false;

        vm.sendingForm = false;
      });
    }

    function selectProductType(productCategorySetting) {
      productCategorySetting.product_category_id = null;

      getProductCategories(productCategorySetting.product_type);
    }

    function selectProductCategory(productCategorySetting) {
      // Add values to setting
      productCategorySetting.settingsByPriceList.forEach(function (setting) {
        setting.product_type = productCategorySetting.product_type;
        setting.product_category_id = productCategorySetting.product_category_id;
      });
    }

    function getProductCategories(product_type) {
      if (vm.productCategoriesByType[product_type]) {
        vm.productCategories = vm.productCategoriesByType[product_type];
        getAvailableProductCategoriesByType(vm.productCategories);

        return;
      }

      vm.loadingProductCategories = true;
      ProductCategoryService.getProductCategories({
        get: 'active',
        by_product_type: product_type,
      }).then(function (data) {
        vm.productCategoriesByType[product_type] = data.items;

        vm.productCategories = vm.productCategoriesByType[product_type];
        getAvailableProductCategoriesByType(vm.productCategories);

        vm.loadingProducts = false;
      });
    }

    function getAvailableProductCategoriesByType(productCategories) {
      vm.availableProductCategoriesByType = [];

      var productCategorySetting, found;

      productCategories.forEach(function (productCategory) {
        found = false;
        for (var j = 0; j < vm.productCategorySettings.length; j++) {
          productCategorySetting = vm.productCategorySettings[j];
          if (productCategory.id === productCategorySetting.product_category.id) {
            // Found in second array
            found = true;
            break;
          }
        }

        if (!found) {
          vm.availableProductCategoriesByType.push(productCategory);
        }
      });
    }

    function toggleEditMode(setting) {
      setting.editMode = !setting.editMode;

      if (!setting.editMode) {
        _restoreOriginalValues(setting);
      } else {
        setting.originalValues = angular.copy(setting);
      }
    }

    // Restore item original values - Edit mode
    function _restoreOriginalValues(setting) {
      setting.settingsByPriceList.forEach(function (priceListSetting) {
        setting.originalValues.settingsByPriceList.forEach(function (originalValue) {
          if (priceListSetting.id === originalValue.id) {
            priceListSetting.percentage = originalValue.percentage;
            return;
          }
        });
      });
    }
  }
})();
